/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Model usage statistics
 */
export type ModelUsage = {
  /**
   * Number of times used
   */
  count: number;
  /**
   * Model name
   */
  name: string;
};

/** @internal */
export const ModelUsage$inboundSchema: z.ZodMiniType<ModelUsage, unknown> = z
  .object({
    count: z.int(),
    name: z.string(),
  });

export function modelUsageFromJSON(
  jsonString: string,
): SafeParseResult<ModelUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ModelUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ModelUsage' from JSON`,
  );
}
